module.exports = __webpack_public_path__ + "img/5_en.77622438.png";